exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fet-contenteditable[data-v-fe1ca914]{display:inline-block;word-break:break-word}.fet-contenteditable[data-v-fe1ca914]:empty:before{content:attr(placeholder);-webkit-text-fill-color:#ddd}.fet-contenteditable.single-row-content[data-v-fe1ca914]{white-space:nowrap;overflow:hidden}", ""]);

// exports
